// STUB (issue #241): the hero is still placeholder artwork. To use a real photo, add it
// (same aspect ratio) to the marketing assets and change the matching import below.
import aboutHero from './about-hero.svg'
import aboutStory from '../about-1.jpg'

export const ABOUT_IMAGES = {
  hero: { src: aboutHero, width: 1920, height: 1080 },
  story: { src: aboutStory, width: 1448, height: 1086 },
} as const
